import './style.scss'

import { mapGetters } from 'vuex'
import Logo from 'components/Logo'
import Burger from 'components/Burger'
import LinkGroup from 'components/LinkGroup'
import Link from 'components/Link'
import Accordion from 'components/Accordion'

export default {
  name: 'MobileNav',
  data: () => ({
    ESCAPE_KEY: 27
  }),
  computed: {
    ...mapGetters(['getMenu', 'loaded', 'lang', 'menuOpen', 'otherLangLink', 'error']),
    menu () {
      return this.getMenu('main')
    },
    menuMeta () {
      return this.getMenu('meta')
    },
    menuMetaLinkGroup () { // we have to transform this data to fit the LinkGroup component
      if (this.menuMeta.items) {
        return this.menuMeta.items.map((x) => {
          return {
            title: x.title,
            'internal_link': x.url
          }
        })
      }
    }
  },
  methods: {
    closeMenu () {
      this.$store.dispatch('closeMenu')
    },
    handleKeyDown (e) {
      switch (e.keyCode) {
        case this.ESCAPE_KEY:
          this.closeMenu()
          break
        default:
          break
      }
    }
  },
  beforeMount () {
    document.addEventListener('keydown', this.handleKeyDown.bind(this))
  },
  mounted () {
    this.show = true
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleKeyDown.bind(this))
  },
  render (h) {
    const { loaded, menu, menuOpen, closeMenu, menuMetaLinkGroup, lang, otherLangLink, error } = this
    return (
      <div class='MobileNav'>
        <Logo class='MobileNav__logo' nativeOnClick={closeMenu} />
        <router-link to={lang === 'en' ? '/en/search' : '/suchen'} nativeOnClick={closeMenu}>
          <img class='MobileNav__searchIcon' src='/imgs/searchIcon.svg' alt='searchIcon' />
        </router-link>
        <Burger class='Menu__burger' />
        {menuOpen
          ? <div class='MobileNav__overlay'>
            <nav class='MobileNav__nav'>
              <div class='MobileNav__nav-content'>
                {loaded && menu && menu.items
                  ? <Accordion isNavigation modifiers={['nav']} sections={menu.items} />
                  : 'Loading…'
                }
              </div>
              <div class='MobileNav__meta' onClick={closeMenu}>
                <LinkGroup class='MobileNav__meta-linkgroup' componentData={menuMetaLinkGroup} />
                {!error
                ? <Link title={this.lang === 'en' ? 'Deutsch' : 'English'} class='MobileNav__button' internalLinkAbsolute={otherLangLink} />
                : null}
              </div>
            </nav>
          </div>
        : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/MobileNav/index.js